/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * backend
 * Sends form data to Jira
 * OpenAPI spec version: 1.0.0
 */
import { customInstance } from './custom-instance';
export type FeedbackIamValue = typeof FeedbackIamValue[keyof typeof FeedbackIamValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackIamValue = {
  public_sector: 'public_sector',
  kela65: 'kela65',
  commitment_to_pay: 'commitment_to_pay',
  purchase_service_authorization: 'purchase_service_authorization',
  service_voucher: 'service_voucher',
  sickness_fund: 'sickness_fund',
  occupational_health_care: 'occupational_health_care',
  insurance: 'insurance',
  private: 'private',
} as const;

export interface VaaratapahtumaFeedback {
  description: string;
  toimipaikka: string;
  dateOfOccurrence: Date;
  email: string;
  iam: FeedbackIamValue;
}

export interface AnonymousVaaratapahtumaFeedback {
  description: string;
  toimipaikka: string;
  dateOfOccurrence: Date;
  email: string;
  iam: FeedbackIamValue;
  name: string;
}

export type OrganizationType = typeof OrganizationType[keyof typeof OrganizationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationType = {
  municipality: 'municipality',
  other: 'other',
  wellbeing_area: 'wellbeing_area',
  insurance_company: 'insurance_company',
  community: 'community',
  company: 'company',
} as const;

export type CustomerRelationshipType = typeof CustomerRelationshipType[keyof typeof CustomerRelationshipType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerRelationshipType = {
  hansel_occupational: 'hansel_occupational',
  public_sector: 'public_sector',
  local_occupational: 'local_occupational',
  sickness_fund: 'sickness_fund',
  insurance: 'insurance',
  national_occupational: 'national_occupational',
} as const;

export type OrganizationSubjectType = typeof OrganizationSubjectType[keyof typeof OrganizationSubjectType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationSubjectType = {
  appointment_booking: 'appointment_booking',
  customer_experience: 'customer_experience',
  customer_relationship_management: 'customer_relationship_management',
  remote_consultation: 'remote_consultation',
  extranet_service: 'extranet_service',
  direct_access_physical_therapist: 'direct_access_physical_therapist',
  pricing: 'pricing',
  treatment_and_examinations: 'treatment_and_examinations',
  invoicing: 'invoicing',
  medical_applications: 'medical_applications',
  marketing_and_communication: 'marketing_and_communication',
  other: 'other',
  sales: 'sales',
  supply_of_services: 'supply_of_services',
  sirius: 'sirius',
  agreement_issues: 'agreement_issues',
  electronically_submitted_employee_info: 'electronically_submitted_employee_info',
  oma_terveys_app: 'oma_terveys_app',
  referrals_made_at_terveystalo: 'referrals_made_at_terveystalo',
  data_protection: 'data_protection',
  website: 'website',
  environmental_responsibility: 'environmental_responsibility',
} as const;

export type OrganizationMenuItemType = typeof OrganizationMenuItemType[keyof typeof OrganizationMenuItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationMenuItemType = {
  customer_service_desk: 'customer_service_desk',
  laboratory_examinations: 'laboratory_examinations',
  surgery_and_operations: 'surgery_and_operations',
  imaging_examinations: 'imaging_examinations',
  screening: 'screening',
  oral_health: 'oral_health',
  partner_service: 'partner_service',
  appointment: 'appointment',
  video_consultation: 'video_consultation',
  common: 'common',
} as const;

export type WishToReceiveResponseValue = typeof WishToReceiveResponseValue[keyof typeof WishToReceiveResponseValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WishToReceiveResponseValue = {
  yes: 'yes',
  no: 'no',
} as const;

export interface OrganizationFeedback {
  organizationType: OrganizationType;
  organizationName: string;
  businessId?: string;
  customerRelationship?: CustomerRelationshipType;
  subject: OrganizationSubjectType;
  invoiceNumber?: string;
  menuItem?: OrganizationMenuItemType;
  dateOfOccurrence?: Date;
  description?: string;
  wishToReceiveResponse: WishToReceiveResponseValue;
  email: string;
  toimipaikka: string;
}

export interface AnonymousOrganizationFeedback {
  organizationType: OrganizationType;
  organizationName: string;
  businessId?: string;
  customerRelationship?: CustomerRelationshipType;
  subject: OrganizationSubjectType;
  invoiceNumber?: string;
  menuItem?: OrganizationMenuItemType;
  dateOfOccurrence?: Date;
  description?: string;
  wishToReceiveResponse: WishToReceiveResponseValue;
  email: string;
  toimipaikka: string;
  name: string;
}

export type ResponseMethodValue = typeof ResponseMethodValue[keyof typeof ResponseMethodValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResponseMethodValue = {
  encrypted_email: 'encrypted_email',
  post: 'post',
  app: 'app',
} as const;

export interface MuistutusFeedback {
  onBehalfOf: boolean;
  patientName: string;
  patientSsn?: string;
  patientPhone: string;
  patientEmail?: string;
  patientAddress?: string;
  purchaseServiceCustomer?: boolean;
  representativeName?: string;
  representativeSsn?: string;
  representativePhone?: string;
  representativeEmail?: string;
  representativeAddress?: string;
  toimipaikka: string;
  muistutus?: string;
  responseMethod: ResponseMethodValue;
}

export type CorrectionRequestTypeValue = typeof CorrectionRequestTypeValue[keyof typeof CorrectionRequestTypeValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CorrectionRequestTypeValue = {
  removal: 'removal',
  modification: 'modification',
  addition: 'addition',
  purchaseServiceCustomer: 'purchaseServiceCustomer',
} as const;

export interface CorrectionRequestFeedback {
  location: string;
  requestTypes: CorrectionRequestTypeValue[];
  descriptionRemoval?: string;
  descriptionModification?: string;
  descriptionAddition?: string;
  descriptionPurchaseServiceCustomer?: string;
  address?: string;
  phoneNumber?: string;
  email: string;
}

export type KorjauspyyntoFeedback = CorrectionRequestFeedback;

export type InvoicingTypeValue = typeof InvoicingTypeValue[keyof typeof InvoicingTypeValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoicingTypeValue = {
  feedback: 'feedback',
  thank_you: 'thank_you',
  inquiry: 'inquiry',
} as const;

export interface InvoicingFeedback {
  type: InvoicingTypeValue;
  description?: string;
  visitDate?: Date;
  invoiceNumber?: string;
  email: string;
}

export interface Health {
  message: string;
}

export type FeedbackOnBehalfOfValue = typeof FeedbackOnBehalfOfValue[keyof typeof FeedbackOnBehalfOfValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackOnBehalfOfValue = {
  myself: 'myself',
  my_child: 'my_child',
  my_relative: 'my_relative',
} as const;

export type FeedbackFeedbackTypeValue = typeof FeedbackFeedbackTypeValue[keyof typeof FeedbackFeedbackTypeValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackFeedbackTypeValue = {
  thank_you: 'thank_you',
  suggestion: 'suggestion',
  complaint: 'complaint',
} as const;

export type FeedbackSubjectValue = typeof FeedbackSubjectValue[keyof typeof FeedbackSubjectValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackSubjectValue = {
  other: 'other',
  appointment_booking: 'appointment_booking',
  marketing_and_communication: 'marketing_and_communication',
  environmental_responsibility: 'environmental_responsibility',
  customer_service: 'customer_service',
  arrival_to_appointment: 'arrival_to_appointment',
  quality_of_care: 'quality_of_care',
  examination: 'examination',
  billing_or_payment: 'billing_or_payment',
  pricing_or_campaigns: 'pricing_or_campaigns',
  online_store: 'online_store',
  data_protection_and_security: 'data_protection_and_security',
  remote_services: 'remote_services',
  premises: 'premises',
  applications_or_electronic_services: 'applications_or_electronic_services',
} as const;

export type FeedbackServiceValue = typeof FeedbackServiceValue[keyof typeof FeedbackServiceValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackServiceValue = {
  oral_health: 'oral_health',
  customer_service_point: 'customer_service_point',
  doctor_appointment: 'doctor_appointment',
  nurse_appointment: 'nurse_appointment',
  other_specialist_appointment: 'other_specialist_appointment',
  laboratory_services: 'laboratory_services',
  procedure_or_surgery: 'procedure_or_surgery',
  imaging: 'imaging',
  occupational_health_services: 'occupational_health_services',
  remote_appointment_or_digital_services: 'remote_appointment_or_digital_services',
  rehabilitation_services: 'rehabilitation_services',
  other_service: 'other_service',
  terveystalo_app: 'terveystalo_app',
  terveystalo_website: 'terveystalo_website',
} as const;

export type WishToReceiveReplyValue = typeof WishToReceiveReplyValue[keyof typeof WishToReceiveReplyValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WishToReceiveReplyValue = {
  yes: 'yes',
  no: 'no',
} as const;

export type PreferredContactMethodValue = typeof PreferredContactMethodValue[keyof typeof PreferredContactMethodValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreferredContactMethodValue = {
  phone: 'phone',
  email: 'email',
} as const;

export interface Feedback {
  feedbackOnBehalfOf: FeedbackOnBehalfOfValue;
  onBehalfOfName?: string;
  feedbackType: FeedbackFeedbackTypeValue;
  feedbackIam?: FeedbackIamValue;
  feedbackEmployer?: string;
  feedbackSubject: FeedbackSubjectValue;
  feedbackSubjectOther?: string;
  feedbackService?: FeedbackServiceValue;
  dateOfOccurrence: Date;
  feedbackDescription?: string;
  wishToReceiveReply: WishToReceiveReplyValue;
  preferredContactMethod?: PreferredContactMethodValue;
  email?: string;
  phone?: string;
  toimipaikka: string;
}

export type FeedbackCreationParams = Feedback;

export interface AnonymousFeedback {
  feedbackOnBehalfOf: FeedbackOnBehalfOfValue;
  onBehalfOfName?: string;
  feedbackType: FeedbackFeedbackTypeValue;
  feedbackIam?: FeedbackIamValue;
  feedbackEmployer?: string;
  feedbackSubject: FeedbackSubjectValue;
  feedbackSubjectOther?: string;
  feedbackService?: FeedbackServiceValue;
  dateOfOccurrence: Date;
  feedbackDescription?: string;
  wishToReceiveReply: WishToReceiveReplyValue;
  preferredContactMethod?: PreferredContactMethodValue;
  email?: string;
  phone?: string;
  toimipaikka: string;
  name?: string;
}

export type AnonymousFeedbackCreationParams = AnonymousFeedback;

/**
 * Processed Toimipaikka data for frontend
 */
export interface ToimipaikkaData {
  id: string;
  objectKey?: string;
  name: string;
  dhKoodi?: string;
  katuosoite?: string;
  kaupunki?: string;
  toimipaikanAlue?: string;
}

export type SubmitVaaratapahtumaFeedback201 = {
  message: string;
};

export type SubmitAnonymousVaaratapahtumaFeedback201 = {
  message: string;
};

export type SubmitOrganizationFeedback201 = {
  message: string;
};

export type SubmitAnonymousOrganizationFeedback201 = {
  message: string;
};

export type SubmitMuistutus201 = {
  message: string;
};

export type SubmitKorjauspyynto201 = {
  message: string;
};

export type SubmitInvoicingFeedback201 = {
  message: string;
};

export type ClearCache200 = {
  message: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getBackend = () => {
/**
 * Submit vaaratapahtuma feedback (authenticated users only)
 * @summary Submit patient adverse event feedback to JIRA
 */
const submitVaaratapahtumaFeedback = (
    vaaratapahtumaFeedback: VaaratapahtumaFeedback,
 options?: SecondParameter<typeof customInstance<SubmitVaaratapahtumaFeedback201>>,) => {
      return customInstance<SubmitVaaratapahtumaFeedback201>(
      {url: `/vaaratapahtuma`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vaaratapahtumaFeedback
    },
      options);
    }
  
/**
 * Submit vaaratapahtuma feedback (anonymous users)
 * @summary Submit patient adverse event feedback to JIRA without authentication
 */
const submitAnonymousVaaratapahtumaFeedback = (
    anonymousVaaratapahtumaFeedback: AnonymousVaaratapahtumaFeedback,
 options?: SecondParameter<typeof customInstance<SubmitAnonymousVaaratapahtumaFeedback201>>,) => {
      return customInstance<SubmitAnonymousVaaratapahtumaFeedback201>(
      {url: `/vaaratapahtuma/anonymous`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: anonymousVaaratapahtumaFeedback
    },
      options);
    }
  
/**
 * Submit organization feedback (authenticated)
 * @summary Submit organization feedback to JIRA
 */
const submitOrganizationFeedback = (
    organizationFeedback: OrganizationFeedback,
 options?: SecondParameter<typeof customInstance<SubmitOrganizationFeedback201>>,) => {
      return customInstance<SubmitOrganizationFeedback201>(
      {url: `/organization`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organizationFeedback
    },
      options);
    }
  
/**
 * Submit anonymous organization feedback
 * @summary Submit anonymous organization feedback to JIRA
 */
const submitAnonymousOrganizationFeedback = (
    anonymousOrganizationFeedback: AnonymousOrganizationFeedback,
 options?: SecondParameter<typeof customInstance<SubmitAnonymousOrganizationFeedback201>>,) => {
      return customInstance<SubmitAnonymousOrganizationFeedback201>(
      {url: `/organization/anonymous`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: anonymousOrganizationFeedback
    },
      options);
    }
  
/**
 * Submit muistutus (potilaslain mukainen muistutus)
 * @summary Submit patient act reminder to JIRA
 */
const submitMuistutus = (
    muistutusFeedback: MuistutusFeedback,
 options?: SecondParameter<typeof customInstance<SubmitMuistutus201>>,) => {
      return customInstance<SubmitMuistutus201>(
      {url: `/api/muistutus`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: muistutusFeedback
    },
      options);
    }
  
/**
 * Submit korjauspyynto (authenticated users only)
 * @summary Submit personal data correction request to JIRA
 */
const submitKorjauspyynto = (
    correctionRequestFeedback: CorrectionRequestFeedback,
 options?: SecondParameter<typeof customInstance<SubmitKorjauspyynto201>>,) => {
      return customInstance<SubmitKorjauspyynto201>(
      {url: `/api/korjauspyynto`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: correctionRequestFeedback
    },
      options);
    }
  
/**
 * Submit invoicing feedback
 * @summary Submit invoicing feedback to JIRA
 */
const submitInvoicingFeedback = (
    invoicingFeedback: InvoicingFeedback,
 options?: SecondParameter<typeof customInstance<SubmitInvoicingFeedback201>>,) => {
      return customInstance<SubmitInvoicingFeedback201>(
      {url: `/invoicing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invoicingFeedback
    },
      options);
    }
  
const getHealth = (
    
 options?: SecondParameter<typeof customInstance<Health>>,) => {
      return customInstance<Health>(
      {url: `/api/health`, method: 'GET'
    },
      options);
    }
  
const createFeedback = (
    feedback: Feedback,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/feedbacks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: feedback
    },
      options);
    }
  
const createAnonymousFeedback = (
    anonymousFeedback: AnonymousFeedback,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/feedbacks/anonymous`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: anonymousFeedback
    },
      options);
    }
  
/**
 * Get list of Toimipaikka objects from JSM Assets
Returns a cached list that is refreshed every hour
 * @summary Get Toimipaikka list
 */
const getToimipaikka = (
    
 options?: SecondParameter<typeof customInstance<ToimipaikkaData[]>>,) => {
      return customInstance<ToimipaikkaData[]>(
      {url: `/api/assets/toimipaikka`, method: 'GET'
    },
      options);
    }
  
/**
 * Clear the Toimipaikka cache (for testing)
 * @summary Clear Toimipaikka cache
 */
const clearCache = (
    
 options?: SecondParameter<typeof customInstance<ClearCache200>>,) => {
      return customInstance<ClearCache200>(
      {url: `/api/assets/clear-cache`, method: 'POST'
    },
      options);
    }
  
return {submitVaaratapahtumaFeedback,submitAnonymousVaaratapahtumaFeedback,submitOrganizationFeedback,submitAnonymousOrganizationFeedback,submitMuistutus,submitKorjauspyynto,submitInvoicingFeedback,getHealth,createFeedback,createAnonymousFeedback,getToimipaikka,clearCache}};

type AwaitedInput<T> = PromiseLike<T> | T;

    type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export type SubmitVaaratapahtumaFeedbackResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBackend>['submitVaaratapahtumaFeedback']>>>
export type SubmitAnonymousVaaratapahtumaFeedbackResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBackend>['submitAnonymousVaaratapahtumaFeedback']>>>
export type SubmitOrganizationFeedbackResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBackend>['submitOrganizationFeedback']>>>
export type SubmitAnonymousOrganizationFeedbackResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBackend>['submitAnonymousOrganizationFeedback']>>>
export type SubmitMuistutusResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBackend>['submitMuistutus']>>>
export type SubmitKorjauspyyntoResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBackend>['submitKorjauspyynto']>>>
export type SubmitInvoicingFeedbackResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBackend>['submitInvoicingFeedback']>>>
export type GetHealthResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBackend>['getHealth']>>>
export type CreateFeedbackResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBackend>['createFeedback']>>>
export type CreateAnonymousFeedbackResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBackend>['createAnonymousFeedback']>>>
export type GetToimipaikkaResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBackend>['getToimipaikka']>>>
export type ClearCacheResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBackend>['clearCache']>>>
